var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/chart2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.50033 18.3333H12.5003C16.667 18.3333 18.3337 16.6667 18.3337 12.5V7.49999C18.3337 3.33332 16.667 1.66666 12.5003 1.66666H7.50033C3.33366 1.66666 1.66699 3.33332 1.66699 7.49999V12.5C1.66699 16.6667 3.33366 18.3333 7.50033 18.3333Z",
    stroke: "#377DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.917 15.4167C13.8337 15.4167 14.5837 14.6667 14.5837 13.75V6.25001C14.5837 5.33334 13.8337 4.58334 12.917 4.58334C12.0003 4.58334 11.2503 5.33334 11.2503 6.25001V13.75C11.2503 14.192 11.4259 14.616 11.7385 14.9285C12.051 15.2411 12.475 15.4167 12.917 15.4167ZM7.08366 15.4167C8.00033 15.4167 8.75033 14.6667 8.75033 13.75V10.8333C8.75033 9.91668 8.00033 9.16668 7.08366 9.16668C6.16699 9.16668 5.41699 9.91668 5.41699 10.8333V13.75C5.41699 14.192 5.59259 14.616 5.90515 14.9285C6.21771 15.2411 6.64163 15.4167 7.08366 15.4167Z",
    stroke: "#377DFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.f2cc96acc58d31753625583da72818a1.svg";
export { ForwardRef as ReactComponent };